const comprobante = {
  readComprobante: 'comprobante/{{uuid_comprobante}}',
  readComprobantePdf: 'comprobante/{{uuid}}/pdf',
  readComprobanteTipos: 'comprobantes-tipo/{{pais}}'
}

export default comprobante
